import { render, staticRenderFns } from "./TariffDetails.vue?vue&type=template&id=6541ff56&scoped=true"
import script from "./TariffDetails.vue?vue&type=script&lang=js"
export * from "./TariffDetails.vue?vue&type=script&lang=js"
import style0 from "./TariffDetails.vue?vue&type=style&index=0&id=6541ff56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541ff56",
  null
  
)

export default component.exports